import { liteClient as algoliasearch } from 'algoliasearch/lite'
import { InstantSearch, Configure } from 'react-instantsearch'
import React, { PropsWithChildren, useMemo } from 'react'

export const SearchProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const searchClient = useMemo(() => {
    return algoliasearch(
      process.env.NEXT_PUBLIC_ALGOLIA_APP_ID || 'PGYY5JY8KO',
      process.env.NEXT_PUBLIC_ALGOLIA_API_KEY || 'ad1cc03028d160958e8254786540b76c',
    )
  }, [])

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME || 'production_crawler_pages'}
    >
      <Configure hitsPerPage={20} />
      {children}
    </InstantSearch>
  )
}